import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getOverviewReportOptions } from 'api';

// Then, handle actions in your reducers:
const overviewReportOptionsSlice = createSlice({
  name: 'overviewReportOptions',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    overviewReportOptionsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    overviewReportOptionsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    overviewReportOptionsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    overviewReportOptionsResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  overviewReportOptionsFetchStart,
  overviewReportOptionsFetchSuccess,
  overviewReportOptionsFetchFail,
  overviewReportOptionsResetState,
} = overviewReportOptionsSlice.actions;

// The reducer
export const overviewReportOptionsReducer = overviewReportOptionsSlice.reducer;

// Asynchronous thunk action
export const overviewReportOptionsFetch = (id: string) => (dispatch) => {
  dispatch(overviewReportOptionsFetchStart());

  getOverviewReportOptions(id)
    .then((overviewReportOptions) => {
      dispatch(overviewReportOptionsFetchSuccess(overviewReportOptions.data));
    })
    .catch((error) => {
      dispatch(overviewReportOptionsFetchFail(error));
    });
};
